export const NAV_ITEMS = [
  { label: "首屏要闻", href: "#top" },
  { label: "今日热点", href: "#hot" },
  { label: "爆料频道", href: "#channels" },
  { label: "最新资讯", href: "#latest" },
  { label: "关于与投稿", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export const TICKER_ITEMS = [
  "线索征集：消费维权类爆料通道已开通，欢迎私信投稿",
  "热点关注：预付式消费纠纷集中上升，谨慎大额充值",
  "民生话题：多地反映老旧小区电梯加装进展缓慢",
  "出行视角：网约车动态计价引发热议，透明化待完善",
  "栏目公告：编辑部每周二集中核处邮件与表单线索",
];

export const HERO_HEADLINE =
  "预付式消费藏隐忧：多位消费者反映办卡后遭遇退费难";
export const HERO_EXCERPT =
  "健身、美容、教培等预付式消费纠纷持续增多。多位网友通过每日爆料曝光台反映，冲动办卡后遭遇退款难、转店难。编辑部已启动跟进核实，欢迎更多线索补充。";
export const HERO_TAG = "独家追踪";
export const HERO_CATEGORY = "消费维权";
export const HERO_TIME = "今日 09:26";
export const HERO_HEAT = "关注度 2.4万";

export const HERO_QUICK = [
  {
    tag: "民生",
    title: "老旧小区加装电梯，居民盼统一规范提速",
    time: "10 分钟前",
  },
  {
    tag: "职场",
    title: "超长工时再引热议：效率与休息如何兼得",
    time: "38 分钟前",
  },
  {
    tag: "出行",
    title: "网约车动态计价引关注，乘客期待更透明",
    time: "1 小时前",
  },
];

export const CATEGORIES = [
  {
    id: "consume",
    name: "消费维权",
    en: "Consumer Rights",
    desc: "预付办卡、售后推诿、虚假宣传等消费纠纷线索",
    count: 1286,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20consumer%20rights%20after%20sales%20theme%2C%20person%20holding%20receipt%20documents%20and%20mobile%20showing%20refund%20complaint%20app%2C%20soft%20natural%20lighting%2C%20muted%20warm%20tones%2C%20clean%20composition%2C%20high%20detail&width=720&height=540&seq=dp-cat-consume&orientation=squarish",
  },
  {
    id: "livelihood",
    name: "民生关注",
    en: "Livelihood",
    desc: "居住、教育、医疗、社区服务等身边事线索",
    count: 987,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20urban%20livelihood%20community%20theme%2C%20residents%20discussing%20by%20old%20residential%20elevator%20building%20at%20golden%20hour%2C%20natural%20warm%20light%2C%20documentary%20style%2C%20clean%20composition%2C%20high%20detail&width=720&height=540&seq=dp-cat-live&orientation=squarish",
  },
  {
    id: "work",
    name: "职场观察",
    en: "Workplace",
    desc: "工时、薪酬、职场公平等劳动者议题线索",
    count: 653,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20workplace%20office%20theme%2C%20focused%20young%20employees%20at%20desks%20with%20laptop%20late%20afternoon%20warm%20window%20light%2C%20documentary%20style%2C%20natural%20tones%2C%20clean%20composition%2C%20high%20detail&width=720&height=540&seq=dp-cat-work&orientation=squarish",
  },
  {
    id: "traffic",
    name: "出行交通",
    en: "Transport",
    desc: "网约车、公共交通、停车场等出行线索",
    count: 514,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20transportation%20mobility%20theme%2C%20passenger%20looking%20at%20smartphone%20in%20car%20while%20waiting%20during%20evening%20commute%20with%20warm%20city%20lights%2C%20documentary%20style%2C%20natural%20tones%2C%20clean%20composition&width=720&height=540&seq=dp-cat-traffic&orientation=squarish",
  },
  {
    id: "food",
    name: "食品安全",
    en: "Food Safety",
    desc: "外卖后厨、食品标签、餐饮卫生等线索",
    count: 443,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20food%20safety%20inspection%20theme%2C%20food%20delivery%20package%20with%20sealed%20sticker%20on%20table%20near%20restaurant%20kitchen%2C%20soft%20warm%20lighting%2C%20documentary%20style%2C%20muted%20tones%2C%20clean%20composition&width=720&height=540&seq=dp-cat-food&orientation=squarish",
  },
  {
    id: "hotspot",
    name: "社会热点",
    en: "Hot Spot",
    desc: "全网热议话题、现象级事件线索与解读",
    count: 321,
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20newsroom%20photography%2C%20social%20hotspot%20theme%2C%20city%20crowd%20and%20news%20headlines%20on%20phones%20under%20street%20lights%20at%20dusk%2C%20documentary%20style%2C%20warm%20tones%2C%20dynamic%20clean%20composition%2C%20high%20detail&width=720&height=540&seq=dp-cat-hotspot&orientation=squarish",
  },
];

export const HOT_RANK = [
  {
    title: "预付式消费退款难：办卡一时爽，退费两行泪",
    category: "消费维权",
    heat: "2.4万",
    tag: "已核实",
  },
  {
    title: "老旧小区加装电梯争议：费用分摊如何更公平",
    category: "民生关注",
    heat: "1.9万",
    tag: "跟进中",
  },
  {
    title: "网约车动态计价再引热议，计费逻辑何时透明",
    category: "出行交通",
    heat: "1.6万",
    tag: "独家",
  },
  {
    title: "外卖后厨卫生成焦点，明厨亮灶能否真正落地",
    category: "食品安全",
    heat: "1.3万",
    tag: "热点",
  },
  {
    title: "新能源车电池衰减，质保条款边界在哪里",
    category: "消费维权",
    heat: "0.9万",
    tag: "征集线索",
  },
];

export const FEED_TABS = ["全部", "消费维权", "民生关注", "职场观察", "出行交通", "食品安全"];

export const FEED_ITEMS = [
  {
    id: 1,
    category: "消费维权",
    title: "健身房办卡后频繁闭店，消费者预付款该何去何从",
    excerpt:
      "多位消费者反映在健身房办卡不久后门店悄然转手或歇业，预付款追索无门。编辑部提醒：大额预付前先确认商家资质与资金监管情况，并保留付款凭证。",
    time: "2 小时前",
    heat: "2.4万",
    tag: "已核实",
  },
  {
    id: 2,
    category: "民生关注",
    title: "老旧小区加装电梯进展不一，费用分摊成最大堵点",
    excerpt:
      "加装电梯本是民生好事，却因楼层分摊、采光影响等争议推进缓慢。多位网友希望有更统一的规范流程与补贴标准，编辑部正在整理各地真实案例。",
    time: "3 小时前",
    heat: "1.9万",
    tag: "跟进中",
  },
  {
    id: 3,
    category: "职场观察",
    title: "「数字加班」争议升温：打卡之外的工作时间如何认定",
    excerpt:
      "远程办公普及后，线上沟通、随时待命是否应计入工时成为热议话题。不少职场人欢迎关于加班认定与补偿的更清晰规则。",
    time: "5 小时前",
    heat: "1.5万",
    tag: "热点",
  },
  {
    id: 4,
    category: "出行交通",
    title: "网约车动态计价逻辑受关注，乘客呼唤明明白白消费",
    excerpt:
      "同一段路程在不同时段价格浮动明显，不少乘客希望了解动态加价的触发规则。出行计价透明化是近期高频线索之一。",
    time: "6 小时前",
    heat: "1.3万",
    tag: "独家",
  },
  {
    id: 5,
    category: "食品安全",
    title: "外卖后厨卫生引担忧，平台透明监管何时跟上",
    excerpt:
      "后厨卫生问题屡上热搜，网友期待「明厨亮灶」与第三方抽检能真正覆盖到每一家外卖门店，让每一餐都吃得放心。",
    time: "8 小时前",
    heat: "1.1万",
    tag: "征集线索",
  },
  {
    id: 6,
    category: "消费维权",
    title: "新能源汽车电池衰减，质保条款边界成焦点",
    excerpt:
      "不少车主反映电池衰减速度超出预期，却因「正常损耗」条款被拒更换。三电质保的认定标准引发广泛讨论，欢迎车主补充真实数据。",
    time: "昨天",
    heat: "0.9万",
    tag: "热点",
  },
  {
    id: 7,
    category: "民生关注",
    title: "中小学食堂升级改造，家长呼吁食材全程可追溯",
    excerpt:
      "多地启动校园食堂改造，家长更关心的是食材采购是否透明、营养配比是否合理，希望能有更开放的监督渠道。",
    time: "昨天",
    heat: "0.8万",
    tag: "跟进中",
  },
  {
    id: 8,
    category: "职场观察",
    title: "职场公平议题升温：招聘门槛与年龄问题引思考",
    excerpt:
      "在招聘和晋升中是否存在隐性门槛，成为不少求职者关心的话题。营造公平、开放、尊重专业的职场环境是共同诉求。",
    time: "昨天",
    heat: "0.7万",
    tag: "最新",
  },
  {
    id: 9,
    category: "社会热点",
    title: "社区团购价格战再起，品质与售后成消费者底线",
    excerpt:
      "低价补贴虽吸引人，但生鲜品质、退换货体验才是留存关键。多位用户希望团购平台在价格之外，更关注服务与售后。",
    time: "2 天前",
    heat: "0.6万",
    tag: "最新",
  },
];

export const PRINCIPLES = [
  {
    icon: "ri-shield-check-line",
    title: "真实为先",
    desc: "坚持事实核验，多方求证后再跟进报道，对每一条线索负责。",
  },
  {
    icon: "ri-lock-line",
    title: "保护隐私",
    desc: "严格保护线索提供者身份，未经同意绝不披露来源信息。",
  },
  {
    icon: "ri-error-warning-line",
    title: "有误必纠",
    desc: "报道若有偏差，第一时间更正致歉，做到有错必改、有问必应。",
  },
  {
    icon: "ri-flashlight-line",
    title: "快速跟进",
    desc: "对与公共利益相关的重大线索优先受理，第一时间跟进反馈。",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "提交线索",
    desc: "通过投稿表单或私信，说明事件经过、发生时间地点与诉求。",
  },
  {
    step: "02",
    title: "线索初审",
    desc: "编辑部审核线索的真实性、相关性，并评估社会关注度。",
  },
  {
    step: "03",
    title: "调查跟进",
    desc: "核实事实、联系相关方，符合条件的线索进入专题跟进。",
  },
  {
    step: "04",
    title: "结果反馈",
    desc: "通过更新与私信向提供者反馈进展，推动问题公开透明解决。",
  },
];

export const FAQS = [
  {
    q: "什么样的线索会被优先跟进？",
    a: "与公共利益相关、事实基本清楚、证据相对完整的消费维权、民生问题、食品安全等线索会被优先受理。属于独家内幕或已引发广泛关注的，编辑部会第一时间启动核实。",
  },
  {
    q: "是否支持匿名投稿？我的身份信息会保密吗？",
    a: "支持匿名投稿。我们会对线索提供者的身份与联系方式严格保密，除非事先征得本人同意，否则不会在公开内容中披露来源信息。",
  },
  {
    q: "提交线索后多久能收到回复？",
    a: "一般情况下面向表单与邮件线索，编辑部会在 3–5 个工作日内处理；属于重大或紧急线索的，会在 24 小时内优先联系核实。",
  },
  {
    q: "提供线索需要准备哪些材料？",
    a: "尽量说明事件发生的时间、地点、经过，并提供发票、合同、截图、录音等可验证的证据。材料越具体、越完整，越有助于编辑部快速判断与跟进。",
  },
  {
    q: "「稿件」与「线索」有什么区别？",
    a: "稿件指你整理好的成稿或素材包，线索指尚未成型的事件信息。两者均可投稿，编辑部会分别处理：稿件侧重事实核查与授权，线索则进入选题与核实流程。",
  },
  {
    q: "提交后可以补充或撤回吗？",
    a: "可以。已提交的线索如需补充证据或撤回，可通过底部联系方式告知线索编号即可，我们会按你的意愿处理并保护相关记录。",
  },
];